<template>
  <small class="form-control-feedback text-danger">
    {{text}}
  </small>
</template>

<script>
export default {
  name: 'ErrorDisplay',
  props: ['error'],
  computed: {
    text() {
      return this.error;
    }
  }
}
</script>
